"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentAccountApi = void 0;
const tslib_1 = require("tslib");
const axiosClient_1 = require("../axiosClient");
exports.CurrentAccountApi = {
    makeBaseURI() {
        return '/api/accounts_mgmt/v1/current_account';
    },
    getCurrentAccount() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield (axiosClient_1.ocmClient === null || axiosClient_1.ocmClient === void 0 ? void 0 : axiosClient_1.ocmClient.get(exports.CurrentAccountApi.makeBaseURI()));
            return response === null || response === void 0 ? void 0 : response.data;
        });
    },
};
//# sourceMappingURL=current-account-api.js.map